import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableCell, Checkbox, TableRow } from '@material-ui/core';

const headCells = [
  {
    id: 'process',
    label: 'Processos',
  },
  {
    id: 'templateNames',
    label: 'Templates',
  },
  {
    id: 'consumerUnit',
    label: 'Unidade consumidora',
  },
  {
    id: 'channel',
    label: 'Canal',
  },
  {
    id: 'attempts',
    label: 'Tentativas',
  },
  {
    id: 'createdAt',
    label: 'Data de criação',
  },
  {
    id: 'lastUpdate',
    label: 'Última atualização',
  },
  {
    id: 'message',
    label: 'Mensagem',
  },
  {
    id: 'status',
    label: 'Status',
  },
  {
    id: 'empty',
    label: '',
  },
];

export function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'selecione todos os processos de notificação',
            }}
          />
        </TableCell>
        {headCells.map(headCell => (
          <TableCell key={headCell.id}>{headCell.label}</TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};
